export default "__VITE_ASSET__51ucW8se__"